import { Component, OnInit, Input } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd';

@Component({
  selector: 'app-message-confirm',
  templateUrl: './message-confirm.component.html',
  styleUrls: ['./message-confirm.component.scss']
})
export class MessageConfirmComponent implements OnInit {

  @Input() description: string

  constructor(private modal: NzModalRef) {
  }

  ngOnInit() {}

  sendYes() {
    this.modal.destroy({status: true})
  }

  close() {
    this.modal.destroy({status: false})
  }


}
